'use strict';
import React from 'react';

var Footer = React.createClass({
    displayName: 'Footer',
    propTypes: {
        isHidden: React.PropTypes.bool
    },
    contextTypes: {
        router: React.PropTypes.func.isRequired
    },
    render() {
        if (this.props.isHidden) {
            return false;
        }
        return (
            <div className="footer">
                <div >
                    {this.props.children}
                </div>
            </div>
        );
    }
});

module.exports = Footer;



// WEBPACK FOOTER //
// ./app/components/footer/footer.jsx